import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import Flickity from "flickity";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import Cookies from "js-cookie";
gsap.registerPlugin(ScrollToPlugin);
const HTML = document.querySelector("html");
class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == void 0) {
          const figure = $el.closest("figure");
          if (figure)
            figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure)
          figure.classList.add("img-is-loaded");
      },
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      }
    });
    Fancybox.bind("[data-fancybox]", {
      Hash: false,
      Carousel: {
        Autoscroll: false,
        Toolbar: {
          display: {
            left: ["counter"],
            middle: [],
            right: ["close"]
          }
        },
        Thumbs: false
      }
    });
    const links = document.querySelectorAll("[data-submenu]");
    const toggles = document.querySelectorAll(".toggle-menu");
    let timer = 0;
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          clearTimeout(timer);
          HTML.classList.toggle("open-menu");
          if (HTML.classList.contains("open-menu")) {
            if (window.innerWidth >= 1024 && links[0]) {
              timer = setTimeout(() => {
                links[0].dispatchEvent(new Event("mouseenter"));
              }, 500);
            }
          }
        });
      });
    }
    if (links) {
      let showMenu = function(el, show = true) {
        const target = el.dataset.submenu;
        const submenu = document.querySelector(`.${target}`);
        if (current != false)
          closeSubmenu();
        if (submenu && show) {
          HTML.classList.add("open-submenu");
          el.classList.add("active");
          submenu.classList.add("active");
          current = target;
        }
      }, closeSubmenu = function() {
        document.querySelector(`.${current}`).classList.remove("active");
        document.querySelector(`[data-submenu="${current}"]`).classList.remove("active");
        HTML.classList.remove("open-submenu");
        current = false;
      };
      let current = false;
      document.body.addEventListener("click", (e) => {
        if (current != false && e.target.classList.contains("submenu") == false && e.target.closest(".submenu") == null) {
          closeSubmenu();
        }
      });
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          showMenu(link, true);
        });
        link.addEventListener("mouseenter", (e) => {
          e.preventDefault();
          showMenu(link, true);
        });
      });
      const closesTrigger = document.querySelectorAll(".main-nav .trigger-back");
      if (closesTrigger) {
        closesTrigger.forEach((close) => {
          close.addEventListener("click", (e) => {
            e.preventDefault();
            closeSubmenu();
          });
        });
      }
    }
    const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"]), select.anchors');
    if (anchors) {
      anchors.forEach((anchor) => {
        const offsetY = document.querySelector(".main-header").offsetHeight + 80;
        if (anchor.tagName == "SELECT") {
          anchor.addEventListener("change", () => {
            const target = document.querySelector(anchor.value);
            if (target) {
              gsap.to(window, {
                duration: 0.8,
                ease: "expo.out",
                scrollTo: {
                  y: target,
                  offsetY
                }
              });
            }
          });
        } else {
          anchor.addEventListener("click", (e) => {
            const target = document.querySelector(anchor.getAttribute("href"));
            if (target) {
              gsap.to(window, {
                duration: 0.8,
                ease: "expo.out",
                scrollTo: {
                  y: target,
                  offsetY
                }
              });
              e.preventDefault();
              return false;
            }
          });
        }
      });
    }
    this.accordionGroup();
    this.marquee();
    this.bannerSpectacle();
    this.stickyAnchor();
    this.accordion();
    this.slider();
    this.carousel();
    this.carouselCoverflow();
    this.carouselList();
    this.soundVideo();
    this.tabs();
    this.countdown();
    this.inViewport();
  }
  accordionGroup() {
    const elts = document.querySelectorAll(".accordion-groups");
    if (elts) {
      elts.forEach((el) => {
        const maxAccordion = 3;
        const content = el.querySelector(".content");
        const trigger = el.querySelector(".trigger-group");
        if (trigger && content) {
          let maxHeight = 0;
          window.addEventListener("resize", () => {
            const accordions = content.querySelectorAll(".accordion-item");
            if (accordions.length >= maxAccordion) {
              maxHeight = accordions[maxAccordion - 1].getBoundingClientRect().bottom - el.getBoundingClientRect().top;
              if (!el.classList.contains("open")) {
                gsap.to(content, {
                  height: `${maxHeight}px`,
                  overflow: "hidden",
                  duration: 0.2
                });
              }
            }
          });
          window.dispatchEvent(new Event("resize"));
          trigger.addEventListener("click", (e) => {
            e.preventDefault();
            el.classList.toggle("open");
            const isOpen = el.classList.contains("open");
            gsap.to(content, {
              height: `${isOpen ? content.scrollHeight : maxHeight}px`,
              overflow: "hidden",
              duration: 0.3,
              ease: "circ.inOut",
              onComplete: () => {
                if (isOpen) {
                  gsap.set(content, { clearProps: "height" });
                }
              }
            });
          });
        }
      });
    }
  }
  stickyAnchor() {
    const elts = document.querySelectorAll(".sticky-anchor");
    const header = document.querySelector(".container-header");
    if (elts) {
      elts.forEach((el) => {
        const cursor = el.querySelector(".cursor");
        const triggers = el.querySelectorAll("a");
        window.addEventListener("scroll", () => {
          const scrollY = window.scrollY || window.pageYOffset;
          let current = -1;
          triggers.forEach((trigger, i) => {
            const target = document.querySelector(trigger.getAttribute("href"));
            if (target) {
              const bounds = target.getBoundingClientRect();
              if (bounds.top <= header.offsetHeight && bounds.bottom >= header.offsetHeight && current != i) {
                gsap.to(cursor, {
                  duration: 0.3,
                  height: trigger.offsetHeight,
                  top: trigger.getBoundingClientRect().top - el.getBoundingClientRect().top
                });
                current = i;
              }
            }
          });
        });
      });
    }
  }
  bannerSpectacle() {
    const elts = document.querySelectorAll(".msg-sticky");
    if (elts) {
      elts.forEach((el) => {
        const trigger = el.querySelector(".trigger-close");
        if (trigger) {
          trigger.addEventListener("click", (e) => {
            e.preventDefault();
            gsap.to(el, {
              duration: 0.3,
              ease: "circ.inOut",
              height: 0,
              onComplete: () => {
                Cookies.set("hidden-banner", true, { expires: 2 });
              }
            });
          });
        }
      });
    }
  }
  tabs() {
    const elts = document.querySelectorAll(".tabs");
    if (elts) {
      elts.forEach((el) => {
        const headers = el.querySelectorAll(".tabs-header a");
        const container = el.querySelector(".tabs-container");
        const items = el.querySelectorAll(".tabs-item");
        const select = el.querySelector(".tabs-header select");
        if (headers && items) {
          let goto = function(index) {
            if (index == current)
              return;
            if (items[index]) {
              let delay = 0;
              if (current >= 0) {
                headers[current].classList.remove("active");
                gsap.to(items[current], {
                  autoAlpha: 0,
                  y: "-2rem",
                  ease: "circ.inOut",
                  duration: 0.3
                });
                delay = 0.15;
              }
              headers[index].classList.add("active");
              gsap.fromTo(items[index], {
                y: "2rem",
                autoAlpha: 0
              }, {
                ease: "circ.inOut",
                duration: 0.3,
                autoAlpha: 1,
                y: "0px",
                delay
              });
              current = index;
              window.dispatchEvent(new Event("resize"));
            }
          };
          let current = -1;
          window.addEventListener("resize", () => {
            gsap.to(container, {
              ease: "circ.inOut",
              duration: 0.3,
              height: items[current].offsetHeight
            });
          });
          if (select) {
            select.addEventListener("change", () => {
              goto(select.value);
            });
          }
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              goto(i);
            });
          });
          goto(0);
        }
      });
    }
  }
  isotopeGrid() {
    const elts = document.querySelectorAll(".isotope-grid");
    if (elts) {
      elts.forEach((el) => {
        new Isotope(el, {
          itemSelector: ".item",
          layoutMode: "masonry"
        });
      });
    }
  }
  slider() {
    const elts = document.querySelectorAll(".slider");
    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          pageDots: el.dataset.flickityDots == "true" ? true : false,
          autoPlay: el.dataset.flickityAutoplay != void 0 ? parseFloat(el.dataset.flickityAutoplay) : false,
          cellSelector: ".item",
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true
        });
        const navs = el.querySelectorAll(".slider-nav");
        if (navs) {
          navs.forEach((nav) => {
            nav.addEventListener("click", (e) => {
              e.preventDefault();
              if (nav.classList.contains("previous")) {
                flkty.previous();
              } else {
                flkty.next();
              }
            });
          });
        }
      });
    }
  }
  accordion() {
    const elts = document.querySelectorAll(".accordion");
    if (elts) {
      elts.forEach((el) => {
        const items = el.querySelectorAll(".accordion-item");
        const contents = el.querySelectorAll(".accordion-content");
        const headers = el.querySelectorAll(".accordion-header");
        if (items && contents && headers) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (items[i].classList.contains("active")) {
              }
              items.forEach((it, j) => {
                if (j != i) {
                  it.classList.remove("active");
                  gsap.to(contents[j], {
                    ease: "circ.inOut",
                    autoAlpha: 0,
                    height: 0
                  });
                }
              });
              items[i].classList.toggle("active");
              if (contents[i]) {
                gsap.to(contents[i], {
                  ease: "circ.inOut",
                  autoAlpha: items[i].classList.contains("active") ? 1 : 0,
                  height: items[i].classList.contains("active") ? contents[i].children[0].offsetHeight : 0,
                  onComplete: () => {
                    window.dispatchEvent(new Event("resize"));
                  }
                });
              }
            });
            if (items[i].dataset.accordionOpen == "true") {
              header.dispatchEvent(new Event("click"));
            }
          });
        }
      });
    }
  }
  carousel() {
    const elts = document.querySelectorAll(".carousel");
    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          pageDots: false,
          cellSelector: ".item",
          wrapAround: true,
          fade: true,
          cellAlign: "left"
        });
        if (el.dataset.flickityFlex != void 0) {
          flkty.slider.style.display = "flex";
          flkty.cells.forEach((cell) => {
            cell.element.style.height = "100%";
          });
        }
      });
    }
  }
  marquee() {
    const elts = document.querySelectorAll(".marquee:not(.ready)");
    if (window.innerWidth > 700)
      return;
    if (elts) {
      elts.forEach((el) => {
        el.classList.add("ready");
        const line = el.querySelector(".line");
        const scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1);
        const speed = 40;
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();
        const marqueeWidth = line.scrollWidth / 2;
        let position = 0;
        let cursor = 0;
        const animate = (timestamp) => {
          position += speed / 100 * -scrollDirection;
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }
          line.style.transform = `translateX(${position}px)`;
          cursor = requestAnimationFrame(animate);
        };
        const lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
        });
        if (el.dataset.hover) {
          el.addEventListener("mouseenter", () => {
            cancelAnimationFrame(cursor);
          });
          el.addEventListener("mouseleave", () => {
            cursor = requestAnimationFrame(animate);
          });
        }
        cursor = requestAnimationFrame(animate);
      });
    }
  }
  carouselCoverflow() {
    const elts = document.querySelectorAll(".carousel-coverflow");
    if (elts) {
      elts.forEach((el) => {
        const nav = el.querySelectorAll(".carousel-nav a");
        const select = el.querySelector(".carousel-nav select");
        let current = 0;
        if (el.querySelectorAll(".item").length <= 1)
          return false;
        const flkty = new Flickity(el, {
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
          autoPlay: 5e3,
          cellSelector: ".item",
          cellAlign: "center",
          selectedAttraction: 0.04,
          friction: 0.6,
          on: {
            select(index) {
              if (nav) {
                nav[current].classList.remove("active");
                nav[index % nav.length].classList.add("active");
              }
              if (select) {
                const options = select.querySelectorAll("option");
                options[index % nav.length].selected = true;
              }
              current = index % nav.length;
            }
          }
        });
        if (select) {
          select.addEventListener("change", () => {
            flkty.select(select.value);
          });
        }
        if (nav) {
          nav.forEach((link, i) => {
            link.addEventListener("click", (e) => {
              e.preventDefault();
              flkty.select(i);
            });
          });
        }
        function getNeighbors(flkty2, count = 2) {
          const i = flkty2.selectedIndex;
          const n = flkty2.cells.length;
          const idx = (offset) => {
            const j = i + offset;
            if (flkty2.options.wrapAround)
              return (j + n) % n;
            if (j < 0 || j >= n)
              return null;
            return j;
          };
          const before = [];
          const after = [];
          for (let k = 1; k <= count; k++) {
            const jb = idx(-k);
            const ja = idx(+k);
            if (jb !== null)
              before.push(flkty2.cells[jb].element);
            if (ja !== null)
              after.push(flkty2.cells[ja].element);
          }
          return { before: before.reverse(), after };
        }
        function getPrevNextCells() {
          const i = flkty.selectedIndex;
          const n = flkty.cells.length;
          const prevIndex = (i - 1 + n) % n;
          const nextIndex = (i + 1) % n;
          const prevCell = flkty.cells[prevIndex];
          const nextCell = flkty.cells[nextIndex];
          return {
            prevIndex,
            nextIndex,
            prevElem: prevCell.element,
            nextElem: nextCell.element
          };
        }
        function changeClasses() {
          const cells = flkty.getCellElements();
          if (cells.length <= 2)
            return;
          cells.forEach((cell) => {
            cell.classList.remove("is-prev", "is-next");
          });
          const { prevElem, nextElem, prevIndex, nextIndex } = getPrevNextCells();
          prevElem.classList.add("is-prev");
          nextElem.classList.add("is-next");
          const { before, after } = getNeighbors(flkty, 2);
          flkty.cells.forEach((c) => c.element.classList.remove("after-1", "after-2", "before-1", "before-2"));
          if (before[1])
            before[1].classList.add("before-1");
          if (before[0])
            before[0].classList.add("before-2");
          if (after[0])
            after[0].classList.add("after-1");
          if (after[1])
            after[1].classList.add("after-2");
        }
        flkty.on("select", changeClasses);
        changeClasses();
      });
    }
  }
  carouselList() {
    const elts = document.querySelectorAll(".carousel-list");
    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          pageDots: false,
          contain: true,
          cellAlign: "left"
        });
      });
    }
  }
  soundVideo() {
    const elts = document.querySelectorAll("[data-muted]");
    if (elts) {
      elts.forEach((el) => {
        const target = document.querySelector(el.dataset.muted);
        if (target) {
          const video = target.querySelector("video");
          if (video) {
            el.addEventListener("click", (e) => {
              e.preventDefault();
              video.muted = !video.muted;
              el.classList.toggle("is-unmuted");
            });
          }
        }
      });
    }
  }
  countdown() {
    const elts = document.querySelectorAll("[data-countdown]");
    if (elts) {
      elts.forEach((el) => {
        const countDownDate = new Date(el.dataset.countdown).getTime();
        function getTime() {
          const now = Date.now();
          if (now >= countDownDate) {
            return {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0
            };
          }
          const distance = countDownDate - now;
          const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
          const hours = Math.floor(distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
          const minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
          const seconds = Math.floor(distance % (1e3 * 60) / 1e3);
          return {
            days,
            hours,
            minutes,
            seconds
          };
        }
        setTimeout(() => {
          const time = getTime();
          for (const [key, value] of Object.entries(time)) {
            gsap.to(el.querySelector(`.${key}`), {
              autoAlpha: 1
            });
            const countdown = { val: 0 };
            gsap.to(countdown, {
              val: value,
              duration: 1,
              ease: "power1.out",
              onUpdate: () => {
                const value2 = Math.floor(countdown.val);
                const spans = el.querySelector(`.${key}`).querySelectorAll(".value span");
                const val = new String(value2 < 10 ? `0${value2}` : value2);
                spans.forEach((span, i) => {
                  span.textContent = val[i];
                });
              }
            });
          }
          setTimeout(() => {
            const x = setInterval(function() {
              const time2 = getTime();
              for (const [key, value] of Object.entries(time2)) {
                const spans = el.querySelector(`.${key}`).querySelectorAll(".value span");
                const val = new String(value < 10 ? `0${value}` : value);
                spans.forEach((span, i) => {
                  span.textContent = val[i];
                });
              }
            }, 1e3);
          }, 1e3);
        }, 500);
      });
    }
  }
  inViewport() {
    inView.offset({
      bottom: window.innerHeight * 0.1
    });
    inView(".js-reveal:not(.is-visible)").on("enter", function(elt) {
      elt.dispatchEvent(new Event("inview"));
      elt.classList.add("is-visible");
      elt.classList.remove("not-visible");
      const video = elt.querySelector("video");
      window.dispatchEvent(new Event("resize"));
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true" || video && video.dataset.autoplay == "true") {
        const v = video || elt;
        const playPromise = v.play();
        if (playPromise !== null) {
          playPromise.catch(() => {
            v.play();
          });
        }
      }
    }).on("exit", function(elt) {
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" || video && video.dataset.autoplay != "") {
        const v = video || elt;
        v.pause();
      }
      elt.dispatchEvent(new Event("outview"));
      elt.classList.add("not-visible");
    });
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new App();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
